<template>
  <Context ref="context" max-height-if-outside-viewport>
    <div class="peninsula-calendar-settings">
      <FormGroup small-label label="Start" required>
        <Dropdown
          :value="view.start_date_field"
          :disabled="readOnly"
          @input="updateStartField"
        >
          <DropdownItem
            v-for="field in calendarFields"
            :key="field.id"
            :value="field.id"
            :name="field.name"
            :icon="field._.type.iconClass"
          />
        </Dropdown>
      </FormGroup>

      <FormGroup
        v-if="!usesJobSchedule"
        small-label
        label="End"
        class="margin-top-2"
      >
        <Dropdown
          :value="view.end_date_field"
          :disabled="readOnly"
          @input="updateView({ end_date_field: $event })"
        >
          <DropdownItem :value="null" name="No end field" />
          <DropdownItem
            v-for="field in availableEndFields"
            :key="field.id"
            :value="field.id"
            :name="field.name"
            :icon="field._.type.iconClass"
          />
        </Dropdown>
      </FormGroup>

      <FormGroup small-label label="Event color" class="margin-top-2">
        <Dropdown
          :value="view.color_field"
          :disabled="readOnly"
          @input="updateView({ color_field: $event })"
        >
          <DropdownItem :value="null" name="Calendar color" />
          <DropdownItem
            v-for="field in colorFields"
            :key="field.id"
            :value="field.id"
            :name="field.name"
            :icon="field._.type.iconClass"
          />
        </Dropdown>
      </FormGroup>
    </div>
  </Context>
</template>

<script>
import { notifyIf } from '@baserow/modules/core/utils/error'
import context from '@baserow/modules/core/mixins/context'

export default {
  name: 'CalendarSettingsContext',
  mixins: [context],
  props: {
    database: { type: Object, required: true },
    view: { type: Object, required: true },
    fields: { type: Array, required: true },
    readOnly: { type: Boolean, required: true },
  },
  computed: {
    calendarFields() {
      return this.fields.filter((field) =>
        ['date', 'job_schedule'].includes(field.type)
      )
    },
    dateFields() {
      return this.fields.filter((field) => field.type === 'date')
    },
    usesJobSchedule() {
      return this.calendarFields.some(
        (field) =>
          field.id === this.view.start_date_field &&
          field.type === 'job_schedule'
      )
    },
    availableEndFields() {
      const startField = this.dateFields.find(
        (field) => field.id === this.view.start_date_field
      )
      return this.dateFields.filter(
        (field) =>
          field.id !== this.view.start_date_field &&
          (!startField ||
            field.date_include_time === startField.date_include_time)
      )
    },
    colorFields() {
      return this.fields.filter((field) => field.type === 'single_select')
    },
  },
  methods: {
    toggle(...args) {
      return this.$refs.context.toggle(...args)
    },
    async updateStartField(value) {
      const values = { start_date_field: value }
      const field = this.calendarFields.find((item) => item.id === value)
      if (
        field?.type === 'job_schedule' ||
        value === this.view.end_date_field
      ) {
        values.end_date_field = null
      }
      await this.updateView(values)
    },
    async updateView(values) {
      try {
        await this.$store.dispatch('view/update', {
          view: this.view,
          values,
          readOnly:
            this.readOnly ||
            !this.$hasPermission(
              'database.table.view.update',
              this.view,
              this.database.workspace.id
            ),
        })
      } catch (error) {
        notifyIf(error, 'view')
      }
    },
  },
}
</script>
